/**
 * AI Suggest Types
 *
 * Defines typed structures for AI Button suggestion functionality including:
 * - Query building (QueryId, DocInput, BuiltQuery)
 * - Candidate sourcing (CandidateSource, RawCandidate)
 * - Ranking (NormalizedFeatures, RankedCandidate)
 * - API contracts (SuggestRequest, SuggestResponse, etc.)
 *
 * @module types/ai-suggest
 * @see SPEC-012 Requirements 1.1, 2.1, 5.1, 8.1, 9.1
 */
// ============================================================================
// Constants
// ============================================================================
/**
 * Maximum number of backlinks returned in a single suggestion.
 * @see Requirement 1.4 - return at most 5 backlinks
 */
export const MAX_BACKLINKS = 5;
/**
 * Maximum number of tags returned in a single suggestion.
 * @see Requirement 1.4 - return at most 5 tags
 */
export const MAX_TAGS = 5;
/**
 * Hard cap on total candidates per kind.
 * @see Requirement 1.4 - hard cap 8 each
 */
export const HARD_CAP_PER_KIND = 8;
/**
 * Maximum length for recommendation reason text.
 * @see Requirement 1.3 - reason ≤ 140 chars
 */
export const MAX_REASON_LENGTH = 140;
/**
 * Default configuration for candidate pool.
 */
export const DEFAULT_CANDIDATE_POOL_CONFIG = {
    vectorTopK: 50,
    graphNeighbors: 30,
    recencyCount: 30,
};
//# sourceMappingURL=ai-suggest.js.map